import React, { useState, useEffect } from 'react'
import MapGL, { Source, Layer } from 'react-map-gl'

import { Box, Text, theme, Button } from '@thinkingmachines/asimov'
import {
  GradientColorBar,
  Legends,
  Panel,
  Tooltip,
  useMapboxTooltip,
  Geocoder
} from '@thinkingmachines/geofront'

import { factors } from './factors.js'
import './App.css'

const initViewport = {
  latitude: 12.5,
  longitude: 121,
  zoom: 5,
  bearing: 0,
  pitch: 0
}

const Map = ({ props }) => {
  const [viewport, setViewport] = useState(initViewport)
  const [selected, setSelected] = useState('risk')
  const [agg, setAgg] = useState('mun')
  const [hoveredData, onHover] = useMapboxTooltip(
    agg == 'mun' ? 'municities' : 'barangays'
  )

  const selectLayer = layer => {
    setSelected(layer)
  }

  const layerProp = factors.filter(f => f.id == selected)[0]
  const layerColor = layerProp.paint['fill-color'].match(/\(([^)]+)\)/)[1]

  const factorList = factors.map(function (f) {
    return (
      <Button
        className={selected == f.id ? 'selected' : 'not-selected'}
        id={f.id}
        variant='tertiary'
        size='small'
        onClick={d => selectLayer(f.id)}
        color={f['paint']['fill-color']}
      >
        {f.label}
      </Button>
    )
  })

  const formatTooltip = feature => {
    if (!feature) {
      return
    }

    const mainAdmin =
      agg == 'mun' ? feature.properties.Mun_Name : feature.properties.Bgy_Name
    const majorAdmin =
      agg == 'mun' ? feature.properties.Pro_Name : feature.properties.Mun_Name
    let attr = feature.properties[selected]

    if (!attr) {
      attr = 0.0
    } else {
      attr = attr.toFixed(2)
    }

    return (
      <Box>
        <Text fontWeight='bold' fontSize='16px'>
          {' '}
          {mainAdmin}{' '}
        </Text>
        <Text mb='6px' fontSize='12px'>
          {' '}
          {majorAdmin}{' '}
        </Text>

        <Text fontSize='12px'> {layerProp.label + ': ' + attr} </Text>
      </Box>
    )
  }

  useEffect(() => {
    if (viewport.zoom > 9.5 && agg == 'mun') {
      setAgg('bgy')
    } else if (viewport.zoom < 9.5 && agg == 'bgy') {
      setAgg('mun')
    }
  }, [viewport])

  return (
    <MapGL
      {...viewport}
      minZoom={3}
      maxZoom={13}
      width='100%'
      height='100%'
      mapStyle='mapbox://styles/thinkdatasci/cjlhnsa6n0d9n2rmvvmkzvhtx'
      mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_KEY}
      onViewportChange={setViewport}
      style={{ position: 'absolute' }}
      onHover={event => onHover(event)}
    >
      <Source
        id='municities'
        type='vector'
        url='mapbox://thinkdatasci.bprd6wbc'
      >
        <Layer
          source-layer='municities-with-risk-simplifi-0jbo77'
          id='municities'
          type='fill'
          maxzoom={9.5}
          paint={layerProp.paint}
        />
      </Source>
      <Source id='barangays' type='vector' url='mapbox://thinkdatasci.9h6huxga'>
        <Layer
          source-layer='barangays-with-risk-simplifie-boedpm'
          id='barangays'
          type='fill'
          minzoom={9.5}
          paint={layerProp.paint}
        />
      </Source>
      <Tooltip
        closeButton={false}
        closeOnClick={false}
        anchor='top'
        hoveredData={hoveredData}
        render={feature => formatTooltip(hoveredData.feature)}
      />
      <Panel top='20px' right='20px' width='300px' padding='0px'>
        <Geocoder
          accessToken={process.env.REACT_APP_MAPBOX_KEY}
          setViewport={setViewport}
          apiOptions={{ countries: ['ph'], types: ['place'] }}
        />
      </Panel>
      <Panel
        borderRadius='2px'
        top='20px'
        left='20px'
        color='#3C3A3B'
        backgroundColor='#fff'
      >
        {factorList}
      </Panel>
      <GradientColorBar
        title={layerProp.label}
        colors={[
          'hsla(' + layerColor + ',0.0)',
          'hsla(' + layerColor + ',0.5)',
          'hsla(' + layerColor + ',1.0)'
        ]}
        width='300px'
        description={layerProp.description}
        min={0.0}
        max={1.0}
        bottom='40px'
        left='20px'
        backgroundColor='#fff'
        borderRadius='2px'
      />
    </MapGL>
  )
}

export default Map
